import { render, staticRenderFns } from "./KamVerificationList.vue?vue&type=template&id=20605eff&"
import script from "./KamVerificationList.vue?vue&type=script&lang=js&"
export * from "./KamVerificationList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports